export const DIMENSIONS = [
  {
    id: "d1", code: "AE-2026-001", short: "Política & gestión top",
    name: "Políticas y mensajes comunicados al máximo nivel de gestión",
    ref: "Guía OCDE 2021, Sección 2.2 (área 1)",
    def: "Existencia, aprobación, comunicación y revisión periódica de una política empresarial sobre los riesgos identificados.",
    quote: "Políticas y mensajes comunicados al máximo nivel de gestión sobre los riesgos identificados.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "Existencia de política escrita", d: "Cubre los riesgos del Risk Register y está alineada a Líneas Directrices OCDE, OIT, ONU.", r: "OCDE 2.2 + Sección 1" },
      { t: "Aprobación al más alto nivel", d: "Firmada por directorio y comunicada por la conducción.", r: "OCDE 2.2 + 1.1" },
      { t: "Comunicación a la organización", d: "A empleados, supervisores, proveedores, sindicatos.", r: "OCDE 2.2" },
      { t: "Revisión periódica documentada", d: "Cada 2 años según OCDE 2.1.1 y ante cambios materiales.", r: "OCDE 2.1.1 + 2.2" },
    ],
  },
  {
    id: "d2", code: "AE-2026-002", short: "Compra & precios",
    name: "Prácticas de compra y de fijación de precios",
    ref: "Guía OCDE 2021, Sección 2.2 + Recuadro 4",
    def: "Evaluación y medidas de control sobre prácticas de compra para prevenir contribución a horas extra, bajos salarios.",
    quote: "Las prácticas de compra de distribuidores, marcas y sus intermediarios de compra contribuyen a impactos dañinos – tales como horas extra excesivas y forzadas, y bajos salarios.",
    quoteSrc: "Guía OCDE 2021, Recuadro 4",
    criteria: [
      { t: "Evaluación de contribución al daño", d: "Mecanismos (anónimos) para identificar si prácticas contribuyen al daño.", r: "OCDE Recuadro 4" },
      { t: "Seguimiento de indicadores", d: "% modificaciones tardías, % retrasos, días entre modificación y envío.", r: "OCDE Recuadro 4" },
      { t: "Modelo de precios con trabajo decente", d: "FOB incluye costos de salarios, beneficios e inversiones.", r: "OCDE Recuadro 4" },
      { t: "Medidas de control en compras", d: "Fechas finales, comunicación a equipos, planes compartidos, alineamiento.", r: "OCDE Recuadro 4" },
      { t: "Sistema de alerta roja", d: "Procedimientos ante modificaciones tardías con mitigación.", r: "OCDE Recuadro 4" },
    ],
  },
  {
    id: "d3", code: "AE-2026-003", short: "Reglas & procedimientos",
    name: "Reglas y procedimientos relativos a riesgos",
    ref: "Guía OCDE 2021, Sección 2.2 (área 3)",
    def: "Procedimientos documentados que cubren cada riesgo significativo del Risk Register.",
    quote: "Reglas y procedimientos relativos a riesgos.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "Cobertura de procedimientos", d: "Para cada riesgo significativo (significance > 5).", r: "OCDE 2.2" },
      { t: "Ciclo completo de gestión", d: "Cubren identificación, prevención, mitigación, respuesta, reparación.", r: "OCDE Diagrama 1" },
      { t: "Vigencia y actualización", d: "Fecha de última revisión visible y actualización ante cambios.", r: "OCDE 2.2 + 2.1.1" },
      { t: "Aplicabilidad demostrable", d: "Evidencia de aplicación en últimos 12 meses.", r: "OCDE 2.2" },
    ],
  },
  {
    id: "d4", code: "AE-2026-004", short: "Cumplimiento normativo",
    name: "Programas en vigencia para apoyar el cumplimiento normativo",
    ref: "Guía OCDE 2021, Sección 2.2 (área 4)",
    def: "Programas y sistemas para mapear, actualizar y verificar cumplimiento legal.",
    quote: "Programas en vigencia para apoyar el cumplimiento normativo.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "Matriz de requisitos legales", d: "Por sitio con referencia normativa y obligación.", r: "OCDE 2.2" },
      { t: "Actualización ante cambios", d: "Ante reformas regulatorias.", r: "OCDE 2.1.1" },
      { t: "Verificación de cumplimiento", d: "Auditorías internas anuales mínimo.", r: "OCDE 2.2" },
      { t: "Indicadores y reporte", d: "Por sitio reportados a la conducción.", r: "OCDE 2.2" },
    ],
  },
  {
    id: "d5", code: "AE-2026-005", short: "Entrenamientos",
    name: "Entrenamientos, capacidades y saberes de los empleados",
    ref: "Guía OCDE 2021, Sección 2.2 (área 5)",
    def: "Plan anual de capacitación sobre los riesgos en operaciones propias.",
    quote: "Entrenamientos, capacidades y saberes de los empleados en materia de riesgos en las propias operaciones de la empresa.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "Plan anual de capacitación", d: "Cubre los riesgos del Risk Register con horas y responsables.", r: "OCDE 2.2" },
      { t: "Cobertura amplia", d: "Supervisores, operativos, nuevos ingresos, áreas críticas.", r: "OCDE 2.2" },
      { t: "Evaluación de aprendizaje", d: "Retención post-capacitación.", r: "Buenas prácticas" },
      { t: "Documentación de asistencia", d: "Asistencia, contenido y materiales documentados.", r: "OCDE 2.2 + 5" },
    ],
  },
  {
    id: "d6", code: "AE-2026-006", short: "Controles financieros",
    name: "Controles financieros (cohecho y corrupción)",
    ref: "Guía OCDE 2021, Sección 2.2 + Módulo II.11",
    def: "Políticas y procedimientos de seguimiento financiero alineados con Módulo 11.",
    quote: "Controles financieros, tales como políticas y procedimientos para hacer seguimiento, gestionar e informar recursos y transacciones financieras. Véase Módulo 11.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "Política anticohecho", d: "Firmada por personal expuesto.", r: "OCDE Módulo 11" },
      { t: "DD sobre intermediarios", d: "Screening de terceros antes de relación comercial.", r: "OCDE Módulo 11" },
      { t: "Segregación de funciones", d: "En autorización, ejecución y registro de pagos.", r: "OCDE Módulo 11" },
      { t: "Canal específico anticorrupción", d: "Independiente para reportar corrupción.", r: "OCDE Módulo 11" },
    ],
  },
  {
    id: "d7", code: "AE-2026-007", short: "Monitoreo & alerta",
    name: "Procedimientos de monitoreo y sistemas de alerta roja",
    ref: "Guía OCDE 2021, Sección 2.2 + 3.1.1",
    def: "Monitoreo continuo, alerta roja, respuesta inmediata ante peligro crítico.",
    quote: "Procedimientos de monitoreo, incluyendo sistemas de alerta roja, para identificar riesgos de daños antes de que ocurran.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "KPIs de monitoreo", d: "Para cada riesgo significativo con frecuencia y responsable.", r: "OCDE 2.2 + 4" },
      { t: "Sistemas de alerta roja", d: "Alertas ante umbrales críticos.", r: "OCDE 2.2" },
      { t: "Respuesta inmediata", d: "Procedimiento de retiro inmediato ante peligro crítico.", r: "OCDE 3.1.1 textual" },
      { t: "Documentación de incidentes", d: "Incidentes y casi-incidentes con análisis de causa raíz.", r: "OCDE 4" },
    ],
  },
  {
    id: "d8", code: "AE-2026-008", short: "Denuncia interna",
    name: "Canales de denuncia y protección contra represalias",
    ref: "Guía OCDE 2021, Sección 2.2 (área 8)",
    def: "Canales accesibles para informantes internos con protección.",
    quote: "Canales de denuncia y protección contra represalias para informantes internos que reporten malas conductas.",
    quoteSrc: "Guía OCDE 2021, Sección 2.2",
    criteria: [
      { t: "Canales accesibles", d: "Múltiples canales en idiomas de los trabajadores.", r: "OCDE 2.2" },
      { t: "Protección contra represalias", d: "Política explícita con consecuencias.", r: "OCDE 2.2" },
      { t: "Procedimiento de investigación", d: "Documentado con plazos y responsables.", r: "OCDE 2.2" },
      { t: "Reporte de denuncias", d: "Agregado anual a la conducción.", r: "OCDE 2.2 + 5" },
    ],
  },
  {
    id: "d9", code: "AE-2026-009", short: "Reparación · OLGM",
    name: "Procesos que habiliten reparación",
    ref: "Guía OCDE 2021, Sección 2.2 + 6.2",
    def: "Mecanismos de reclamación a nivel operativo (OLGM) gestionados por partes de confianza.",
    quote: "Las empresas deben establecer mecanismos legítimos o cooperar mediante estos mecanismos en la reparación de los impactos negativos sobre los derechos humanos cuando se descubra que han causado dichos impactos o que han contribuido a generarlos.",
    quoteSrc: "Líneas Directrices OCDE IV.A6",
    criteria: [
      { t: "Existencia del OLGM", d: "Distinto del canal de denuncia (Recuadro 8).", r: "OCDE 2.2 + 6.1 + Recuadro 8" },
      { t: "Acceso de partes afectadas", d: "Permite a partes afectadas o representantes presentar reclamos.", r: "OCDE 6.2 textual" },
      { t: "No menoscaba mecanismos locales", d: "No sustituye judiciales/sindicales locales.", r: "OCDE 6.2 textual" },
      { t: "Gestión por partes de confianza", d: "Comité paritario o mediador externo.", r: "OCDE 6.2 textual" },
      { t: "Diferenciación alerta vs reparación", d: "Distingue alerta temprana de reparación.", r: "OCDE Recuadro 8" },
      { t: "Indicadores y aprendizaje", d: "Nº de reclamos, resolución, tiempo, aprendizajes.", r: "OCDE 6 + 4" },
    ],
  },
];

export const MATURITY_LABELS = ["", "Ausente", "Inicial", "Definido", "Gestionado", "Optimizado"];

export const AE_DEFAULT = {
  d1: { ba: { level: 4, notes: "Política integrada DDHH y EHS firmada por CEO 2024, alineada a Líneas Directrices y OIT. Revisión anual." } },
  d2: { ba: { level: 2, notes: "Decisiones de compra centralizadas en HQ. Modelo FOB no incluye trabajo decente explícitamente." } },
  d3: { ba: { level: 4, notes: "Manual cubre 9 de 10 riesgos. SOP wastewater alineado a Higg FEM." } },
  d4: { ba: { level: 4, notes: "Matriz legal AR mantenida por estudio jurídico externo. Auditoría anual." } },
  d5: { ba: { level: 4, notes: "Plan anual 2026 con 47 contenidos. Asistencia trazable por LMS." } },
  d6: { ba: { level: 3, notes: "Política anticohecho firmada. DD básico. Segregación en pagos > USD 50k." } },
  d7: { ba: { level: 3, notes: "KPIs para SST, horas extra, rotación. Procedimiento de retiro inmediato documentado." } },
  d8: { ba: { level: 3, notes: "Canal línea telefónica y formulario digital. Política de no represalia." } },
  d9: { ba: { level: 3, notes: "OLGM con comité paritario. Distinción alerta vs reparación documentada." } },
};

export function buildDefaultMaturityForSite() {
  return { level: 1, notes: "" };
}

export function dimAvg(maturity, did, sites) {
  return sites.reduce((a, s) => a + (maturity[did]?.[s.id]?.level ?? 1), 0) / sites.length;
}

export function maturityColor(level) {
  return ["", "ae-m1", "ae-m2", "ae-m3", "ae-m4", "ae-m5"][Math.round(level)] || "";
}
